class teamHelper{
	constructor() {
		this.bindTeamModal();
	}
	bindTeamModal() {
		var buttons = $('[data-toggle="modal-team"]');
		buttons.each(function(i, el) {
			$(this).click(function(e) {
				e.preventDefault();
				var target = $(this).data('target');
				$(target).modal('show');
			});
		});
	}
}
window.app.add('team', new teamHelper());